module.exports = __webpack_public_path__ + "static/assets/9a6a79a932191940f46063aafc82e5be.svg";